import { render, staticRenderFns } from "./SuppVsMa.vue?vue&type=template&id=4f7805df&lang=pug"
import script from "./SuppVsMa.vue?vue&type=script&lang=js"
export * from "./SuppVsMa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports